import { Component, HostListener, Inject, Input, OnInit, PLATFORM_ID, signal } from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { RouterModule, Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { AuthService } from '../../_services/api/auth.service';
import { TruncatePipe } from '../../_pipes/truncate.pipe';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  @Input() fixed = false;
  isMenuOpen = false;
  isMobile = false;
  isHomePage = false;
  isAdmin = signal(false);

  isLoggedIn = false;
  userName: string | undefined = "";

   constructor(
    @Inject(PLATFORM_ID) private platformId: Object, 
    private authService: AuthService, 
    private router: Router) {}

  ngOnInit() {
    this.authService.isLoggedIn$.subscribe((loggedIn) => {
      this.isLoggedIn = loggedIn;
      if (loggedIn) {
        const userInfo = this.authService.getUserInfo();
        this.userName = userInfo?.username || userInfo?.sub || 'Utilisateur';
      } else {
        this.userName = '';
      }
    });

    this.isLoggedIn = this.authService.isLoggedIn();
    if (this.isLoggedIn) {
      const userInfo = this.authService.getUserInfo();
      this.userName = userInfo?.username || userInfo?.sub || 'Utilisateur';
      this.isAdmin.set(this.authService.isAdmin());
    }


    this.checkScreenSize();
    this.checkCurrentRoute();

    this.setupRouteChangeListener();
    
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        this.checkCurrentRoute();
      });
  }

   checkCurrentRoute() {
    this.isHomePage = this.router.url === '/home' || this.router.url === '/';
  }

  @HostListener('window:resize')
  onResize() {
    if (isPlatformBrowser(this.platformId)) {
      this.checkScreenSize();
    }
  }

  checkScreenSize() {
    if (isPlatformBrowser(this.platformId)) {
      this.isMobile = window.innerWidth <= 768;
    }
    if (!this.isMobile) {
      this.isMenuOpen = false;
    }
  }

  home() {
    this.router.navigate(['/']);
  }

  login() {
    this.router.navigate(['/login']);
  }

  logout() {
    this.isLoggedIn = false;
    this.authService.logout();
    this.closeAllDropdowns();
    this.router.navigate(['/']);
  }

  redirectToSpace(){
    if(this.authService.isAdmin()){
      this.router.navigate(['/admin/dashboard']);
    }else{
      this.router.navigate(['/home']);
    }
  }

  private setupRouteChangeListener() {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        this.closeAllDropdowns();
      });
  }

  closeAllDropdowns() {
    this.isMenuOpen = false;
  }


  toggleMenu(): void {
    this.isMenuOpen = !this.isMenuOpen;
    this.updateBodyScroll();
  }

  closeMenu(): void {
    this.isMenuOpen = false;
    this.updateBodyScroll();
  }

  private updateBodyScroll(): void {
     if (isPlatformBrowser(this.platformId)) {
      if (this.isMenuOpen) {
        document.body.classList.add('menu-open');
      } else {
        document.body.classList.remove('menu-open');
      }
    }
  }

  @HostListener('window:keydown.escape', ['$event'])
  handleEscapeKey(event: Event): void {
    if (this.isMenuOpen) {
      this.closeMenu();
    }
  }

  @HostListener('document:click', ['$event'])
  handleClickOutside(event: Event): void {
    const target = event.target as HTMLElement;
    if (this.isMenuOpen && 
        !target.closest('.mobile-menu') && 
        !target.closest('.hamburger-btn')) {
      this.closeMenu();
    }
  }

  ngOnDestroy(): void {
    if (isPlatformBrowser(this.platformId)) {
      document.body.classList.remove('menu-open');
    }
  }
}